<template>
    <div class="select-version-content">
        <h1 class="top-title">可选择的检测版本</h1>
        
        <ul class="select-version">
            <li class="version" @click="activeVersion = 'college'">
                <div class="mask" v-show="activeVersion === 'college'">
                    <span class="icon-wrap">
                        <img src="@/assets/click.png" alt="选中">
                    </span>
                </div>
                <img class="bg-img" src="@/assets/bachelor.png" alt="大学生版">
            </li> 

            <li class="version" @click="activeVersion = 'graduate'">
                <div class="mask" v-show="activeVersion === 'graduate'">
                    <span class="icon-wrap">
                        <img src="@/assets/click.png" alt="选中">
                    </span>
                </div>
                <img class="bg-img" src="@/assets/master.png" alt="研究生版">
            </li> 

            <li class="version" @click="activeVersion = 'editor'">
                <div class="mask" v-show="activeVersion === 'editor'">
                    <span class="icon-wrap">
                        <img src="@/assets/click.png" alt="选中">
                    </span>
                </div>
                <img class="bg-img" src="@/assets/editor.png" alt="编辑部版">
            </li> 

            <li class="version" @click="activeVersion = 'title'">
                <div class="mask" v-show="activeVersion === 'title'">
                    <span class="icon-wrap">
                        <img src="@/assets/click.png" alt="选中">
                    </span>
                </div>
                <img class="bg-img" src="@/assets/title.png" alt="职称版">
            </li>

            <li class="version" @click="activeVersion = 'aigc'">
                <div class="mask" v-show="activeVersion === 'aigc'">
                    <span class="icon-wrap">
                        <img src="@/assets/click.png" alt="选中">
                    </span>
                </div>
                <img class="bg-img" src="@/assets/aigc.png" alt="AIGC版">
            </li>
        </ul>

        <!-- 提示信息区域 -->
        <div class="version-tip" v-show="activeVersion">
            <div class="version-dec">
                <!-- 动态小三角形 -->
                <h6 class="sanjiao" :style="{ left: triangleLeft }"></h6>
                
                <p v-show="activeVersion === 'college'"><b>维普大学生版</b>：适用大中专、本科阶段的毕业生。</p>
                <p v-show="activeVersion === 'graduate'"><b>维普研究生版</b>：适用硕士、博士论文。</p>
                <p v-show="activeVersion === 'editor'"><b>维普编辑部版</b>：适用期刊、图书、会议论文。</p>
                <p v-show="activeVersion === 'title'"><b>维普职称版</b>：适用职称评审论文、已发表论文。</p>
                <p v-show="activeVersion === 'aigc'"><b>AIGC检测</b>：精准识别AI生成文本，客观判定占比，区分人机写作比例</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // 使用单一变量控制选中状态，默认选中大学生版，如果不想要默认选中可以设为 null
            activeVersion: null 
        }
    },
    computed: {
        // 计算小三角的动态水平位置，使其对准当前选中的卡片
        triangleLeft() {
            const positions = {
                'college': '10%',
                'graduate': '30%',
                'editor': '50%',
                'title': '70%',
                'aigc': '90%'
            };
            return positions[this.activeVersion] || '10%';
        }
    }
}
</script>

<style lang="less" scoped>
/* 推荐加上 scoped 防止样式污染全局 */
.select-version-content {
    /* 白色背景包裹容器 */
    background-color: #ffffff;
    max-width: 1200px; /* 限制最大宽度 */
    margin: 40px auto; /* 整体居中 */
    padding: 40px; /* 内部留白，包住全部选择 */
    border-radius: 8px; /* 轻微圆角提升美观度 */
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05); /* 添加一点高级的阴影感 */
    box-sizing: border-box;

    ul, li {
        list-style: none;
        margin: 0;
        padding: 0;
    }
    p {
        margin: 0;
    }

    .top-title {
        text-align: center;
        font-size: 24px;
        color: #333;
        padding-bottom: 30px;
        margin: 0;
        font-weight: 600;
        letter-spacing: 1px;
    }

    .select-version {
        display: flex;
        justify-content: center; /* 选项居中对齐 */
        align-items: center;
        gap: 24px; /* 使用 gap 代替 margin-right，更优雅 */
        margin-bottom: 24px;

        .version {
            border-radius: 6px;
            position: relative;
            cursor: pointer;
            flex: 1; /* 平分空间 */
            max-width: 215px; /* 控制最大图片宽度 */
            transition: transform 0.2s ease;

            &:hover {
                transform: translateY(-3px); /* 鼠标悬浮轻微上浮效果 */
            }

            /* 遮罩层 */
            .mask {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                // background: url("~@/assets/blackdot.png") repeat; /* 你原来的点阵图 */
                // /* 如果你想换成半透明黑底，可以取消注释下面这行 */
                background: rgba(0, 0, 0, 0.4); 
                border-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 10;

                .icon-wrap {
                    width: 58px;
                    height: 58px;
                    border-radius: 50%;
                    background-color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                    
                    img {
                        width: 30px; /* 根据实际 click.png 大小微调 */
                        height: auto;
                    }
                }
            }

            .bg-img {
                width: 100%;
                height: auto;
                display: block;
                border-radius: 6px;
            }
        }
    }

    .version-tip {
        .version-dec {
            color: #1272D7;
            font-size: 15px;
            line-height: 50px;
            background-color: #F0F7FF;
            border-radius: 4px;
            padding: 0 20px;
            position: relative;
            
            .sanjiao {
                position: absolute;
                top: -10px;
                width: 0;
                height: 0;
                border-bottom: 10px solid #F0F7FF;
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                margin: 0;
                transform: translateX(-50%); /* 配合 left 的百分比居中对齐 */
                transition: left 0.3s ease; /* 三角形移动的过渡动画 */
            }
        }
    }
}
</style>